import { useIntersectionObserver } from '@vueuse/core';

const handleVideoJsPlaying = (player) => {
  if (!player.isAdsPlaying && !player.isVideoEnded && !player.isPaused) {
    player.on('readyforpreroll', () => {
      player.isAdsPlaying = true;
      player.on('adend', () => {
        player.ads.endLinearAdMode();
        player.isAdsPlaying = false;
      });
    });

    player.one('ended', () => {
      player.isVideoEnded = true;
    });

    player.play();

    const videoElements = document instanceof Document ? document.getElementsByTagName('video') : [];
    player.on('playing', (event) => {
      if (videoElements.length > 1) {
        videoElements.forEach((el) => {
          el.playerId !== event.target.id && el.pause();
        });
      }
    });
  }
};

// Intersection Behaviours, change video play/pause according to scrolling
export const interSection = (videoParentElement, player, videoCount, isMobile, isHero) => {
  const { stop } = useIntersectionObserver(
    videoParentElement,
    ([{ isIntersecting }]) => {
      if (isIntersecting) {
        handleVideoJsPlaying(player);
        if (player.isAdsPlaying) {
          player.ima.resumeAd();
        }
      } else if (videoCount > 1 || isMobile) {
        player.pause();
        if (player.isAdsPlaying) {
          player.ima.pauseAd();
        }
      }
    },
    {
      root: null,
      rootMargin: isHero ? '0%' : '-10% 0% -35% 0%',
      threshold: 0.7,
    }
  );
  window.addEventListener('beforeunload', () => stop());
};
